import { MdEmojiEvents } from 'react-icons/md';
import { Resources } from '../../resource';
import { MainPage } from './main-page';

export const name = Resources.worldCupGrandPrixConfig;

export const list = MainPage;

export const icon = MdEmojiEvents;

export const options = { label: 'resource.worldCupGrandPrixConfig' };
